<div class="component-container">
  <i class="material-icons">lock</i>
  <h1>You don't have permission to view this page</h1>
  <h3>{{reason}}</h3>
</div>
